module.exports = __webpack_public_path__ + "static/img/02.a315ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/02.png
// module id = Gnpv
// module chunks = 1